(function() {
  var __sections__ = {};
  (function() {
    for(var i = 0, s = document.getElementById('sections-script').getAttribute('data-sections').split(','); i < s.length; i++)
      __sections__[s[i]] = true;
    })();
    (function() {
  if (!__sections__["gc-private-vip-tour"] && !Shopify.designMode) return;
  try {
    
  (() => {
    const initialiseVIPTours = (scope = document) => {
      scope.querySelectorAll('[data-gc-vip-section]').forEach((section) => {
        section.querySelectorAll('.gc-vip-tour__success, .gc-vip-tour__errors').forEach((message) => {
          const bookingPanel = message.closest('details');
          if (bookingPanel) bookingPanel.open = true;
          if (message.classList.contains('gc-vip-tour__success')) message.focus();
        });

        section.querySelectorAll('[data-gc-weekday]').forEach((field) => {
          if (field.dataset.weekdayReady === 'true') return;
          field.dataset.weekdayReady = 'true';

          const today = new Date();
          field.min = new Date(today.getTime() - (today.getTimezoneOffset() * 60000)).toISOString().split('T')[0];

          field.addEventListener('change', () => {
            const selected = field.value ? new Date(`${field.value}T12:00:00`) : null;
            const weekend = selected && (selected.getDay() === 0 || selected.getDay() === 6);
            field.setCustomValidity(weekend ? 'Please choose a Monday to Friday date.' : '');
            if (weekend) field.reportValidity();
          });
        });
      });
    };

    if (document.readyState === 'loading') {
      document.addEventListener('DOMContentLoaded', () => initialiseVIPTours());
    } else {
      initialiseVIPTours();
    }

    document.addEventListener('shopify:section:load', (event) => initialiseVIPTours(event.target));
  })();

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["gc-story-video"] && !Shopify.designMode) return;
  try {
    
  if (!customElements.get('gc-story-player')) {
    customElements.define('gc-story-player', class extends HTMLElement {
      connectedCallback() {
        this.video = this.querySelector('video');
        if (this.started || !this.video || this.dataset.autoplayOnScroll !== 'true' ||
            !('IntersectionObserver' in window) ||
            window.matchMedia('(prefers-reduced-motion: reduce)').matches ||
            !this.video.paused || this.video.currentTime > 0) return;

        this.onPlay = () => {
          this.started = true;
          this.observer?.disconnect();
        };
        this.video.addEventListener('play', this.onPlay, { once: true });
        this.observer = new IntersectionObserver((entries) => {
          if (!entries.some((entry) => entry.isIntersecting && entry.intersectionRatio >= 0.25)) return;
          this.started = true;
          this.observer.disconnect();
          if (window.matchMedia('(prefers-reduced-motion: reduce)').matches) return;
          const wasMuted = this.video.muted;
          this.video.muted = true;
          this.video.play().catch(() => { this.video.muted = wasMuted; });
        }, { threshold: 0.25 });
        this.observer.observe(this.video);
      }

      disconnectedCallback() {
        this.observer?.disconnect();
        if (this.onPlay) this.video?.removeEventListener('play', this.onPlay);
      }
    });
  }

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["ground-control-address-map"] && !Shopify.designMode) return;
  try {
    
  (() => {
    const selector = '[data-gc-address-map]';
    const drawSelector = '[data-gc-draw-path]';
    const namespace = window.GroundControlAddressMap || (() => {
      const records = new Map();

      const findRoots = (scope) => {
        const roots = [];
        if (scope.matches && scope.matches(selector)) roots.push(scope);
        if (scope.querySelectorAll) roots.push(...scope.querySelectorAll(selector));
        return roots;
      };

      const markDrawComplete = (event) => {
        if (event.animationName !== 'gc-address-coast-draw' && event.animationName !== 'gc-address-route-draw') return;
        event.currentTarget.classList.add('is-draw-complete');
      };

      const reset = (record) => {
        if (!record?.root) return;
        record.active = false;
        record.root.classList.remove('is-animated');
        record.paths.forEach((path) => path.classList.remove('is-draw-complete'));
      };

      const play = (record) => {
        if (!record?.root?.isConnected || record.active) return;
        record.active = true;
        record.root.classList.remove('is-animated');
        record.paths.forEach((path) => path.classList.remove('is-draw-complete'));
        void record.root.offsetWidth;
        record.root.classList.add('is-animated');
      };

      const init = (root) => {
        if (!root || root.dataset.gcAddressMapReady === 'true') return;
        const id = root.dataset.sectionId;
        const previous = records.get(id);
        if (previous?.observer) previous.observer.disconnect();

        const paths = [...root.querySelectorAll(drawSelector)];
        paths.forEach((path) => {
          const length = Math.ceil(path.getTotalLength()) + 2;
          path.style.setProperty('--gc-draw-length', `${length}px`);
          path.addEventListener('animationend', markDrawComplete);
        });

        const record = {
          root,
          target: root.querySelector('.gc-address-map__visual') || root,
          paths,
          active: false,
          observer: null
        };

        root.dataset.gcAddressMapReady = 'true';
        records.set(id, record);

        if (window.matchMedia('(prefers-reduced-motion: reduce)').matches || !('IntersectionObserver' in window)) {
          return;
        }

        root.classList.add('is-animation-ready');
        const observer = new IntersectionObserver((entries) => {
          entries.forEach((entry) => {
            if (entry.isIntersecting && entry.intersectionRatio >= 0.15) {
              play(record);
            } else if (!entry.isIntersecting) {
              reset(record);
            }
          });
        }, { threshold: [0, 0.15], rootMargin: '0px 0px -10% 0px' });

        record.observer = observer;
        observer.observe(record.target);
      };

      const initAll = (scope) => findRoots(scope).forEach(init);

      const destroyAll = (scope) => {
        findRoots(scope).forEach((root) => {
          const id = root.dataset.sectionId;
          const record = records.get(id);
          if (record && record.root === root) {
            if (record.observer) record.observer.disconnect();
            record.paths.forEach((path) => path.removeEventListener('animationend', markDrawComplete));
          }
          records.delete(id);
          delete root.dataset.gcAddressMapReady;
        });
      };

      const replayAll = (scope) => findRoots(scope).forEach((root) => {
        const record = records.get(root.dataset.sectionId);
        if (!record || window.matchMedia('(prefers-reduced-motion: reduce)').matches) return;
        reset(record);
        play(record);
      });

      return { initAll, destroyAll, replayAll, eventsBound: false };
    })();

    window.GroundControlAddressMap = namespace;
    namespace.initAll(document);

    if (!namespace.eventsBound) {
      document.addEventListener('shopify:section:load', (event) => namespace.initAll(event.target));
      document.addEventListener('shopify:section:unload', (event) => namespace.destroyAll(event.target));
      document.addEventListener('shopify:section:select', (event) => namespace.replayAll(event.target));
      namespace.eventsBound = true;
    }
  })();

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["main-header"] && !Shopify.designMode) return;
  try {
    
  (() => {
    let headerObserver;

    const observeHeader = () => {
      headerObserver?.disconnect();
      const header = document.querySelector('.gc-header');
      if (!header) return;

      const updateHeight = () => {
        document.documentElement.style.setProperty('--gc-header-height', `${Math.ceil(header.getBoundingClientRect().height)}px`);
      };

      updateHeight();
      headerObserver = new ResizeObserver(updateHeight);
      headerObserver.observe(header);
    };

    if (document.readyState === 'loading') {
      document.addEventListener('DOMContentLoaded', observeHeader, { once: true });
    } else {
      observeHeader();
    }

    document.addEventListener('shopify:section:load', (event) => {
      if (event.target.matches('.shopify-section--gc-header')) observeHeader();
    });

    document.addEventListener('shopify:section:unload', (event) => {
      if (!event.target.matches('.shopify-section--gc-header')) return;
      headerObserver?.disconnect();
      document.documentElement.style.removeProperty('--gc-header-height');
    });
  })();

  } catch(e) { console.error(e); }
})();
})();
